import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=f0d595be&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0d595be')) {
      api.createRecord('f0d595be', component.options)
    } else {
      api.reload('f0d595be', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=f0d595be&", function () {
      api.rerender('f0d595be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jFz1hjAla5SR/JS/comp/FavElement.vue"
export default component.exports